import * as React from 'react';
import {FunctionComponent} from 'react';
import {classNames} from '../../Support/classNames';

interface OwnProps {
    text?: string | null;
    className?: string;
}

export const Loader: FunctionComponent<OwnProps> = ({text, className}) => {
    return (
        <div className={classNames('loader', className)}>
            <div className="loader__animation loader__animation--inner"></div>
            {text?.length && <div className="loader__description">{text}</div>}
        </div>
    );
};
